module.exports = __webpack_public_path__ + "bootleggers_coffee_cover_example_01_branded.jpg?3ff3b08b2a6ac1126130b26e43b0146e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggers_coffee_cover_example_01_branded.jpg
// module id = 34
// module chunks = 0